import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "../redux/slices/auth/login-slice";
import subscribeSlice from "./slices/subscribe/subscribe-slice";
import totalCountSlice from "./slices/donationCamp/totalCount-slice";
import campCategorySlice from "./slices/donationCamp/campCategory-slice";
import nonprofitsSlice from "./slices/donationCamp/nonprofit-slice";
import blogListSlice from "./slices/blogs/blogList-slice";
import citiesSlice from "./slices/donationCamp/cities-slice";
import causesSlice from "./slices/donationCamp/causes-slice";
import signupSlice from "./slices/auth/signup-slice";
import forgotSlice from "./slices/auth/forgot-slice";
import searchNonprofitSlice from "./slices/donationCamp/searchNonprofit-slice";
import similarNonprofitSlice from "./slices/donationCamp/similarNonprofit-slice";
import campDetailSlice from "./slices/donationCamp/campDetail-slice";
import communityStoriesSlice from "./slices/donationCamp/communityStories-slice";
import campaignsSlice from "./slices/donationCamp/campaigns-slice";
import sponsorSlice from './slices/sponsors/sponsors-slice'
import nearestCitiesSlice from "./slices/location/nearest-cities";
import startBadgeSlice from "./slices/reviews/starBadge";
import badgeStatisticsSlice from "./slices/nonProfit/badge-statistics";
import greatNonProfitSlice from "./slices/about/about-great-nonprofit"
import successStoriesSlice from "./slices/nonProfit/success-stories";
import elliottAdvocacySlice from "./slices/elliottAdvocacy/elliott-advocacy";
import aboutMembersSlice from "./slices/members/about-members";
import nonprofitMissionSlice from "./slices/nonProfit/nonprofit-mission"
import blogCategorySlice from "./slices/blogs/blogCategory-slice";
import blogDetailSlice from "./slices/blogs/blogDetail-slice";
import pressMediaSlice from "./slices/pressMedia/press-media";
import fundersSlice from "./slices/sponsors/funders-slice";
import clientSlice from "./slices/sponsors/client-slice";
import solutionsSlice from "./slices/solutions/solutions-slice";
import endorsementsSlice from "./slices/endorsements/endorsements-slice"
import supporterSlice from "./slices/supporters/supporters";
import donationNumbersSlice from "./slices/donationCamp/donationNumbers-slice";
import donationMakeDifferenceSlice from "./slices/donationCamp/donationMakeDifference-slice";
import careersSlice from "./slices/careers/careers-slice";
import topCausesSlice from "./slices/donationCamp/topCauses-slice";
import faqHelpsSlice from "./slices/faq/faqHelps-slice";
import faqArticlesSlice from "./slices/faq/faqArticles-slice";
import linkToUsSlice from "./slices/linkToUs/linkToUs-slice";
import advertisingSlice from "./slices/advertising/advertising-slice";
import yearBadgeSlice from "./slices/yearBadge/yearBadge-slice";
import getBadgeSlice from "./slices/donationCamp/getBadge-slice";
import faqUserGuideSlice from "./slices/faq/faqUserGuide-slice";
import faqTopRatedAwardsSlice from "./slices/faq/faqTopRatedAwards-slice";
import faqNonprofitSlice from "./slices/nonProfit/nonprofitFaq-slice";
import faqDetailsSlice from "./slices/faq/faqDetail-slice";
import contactUsFaqSlice from "./slices/faq/contactUsFaq-slice";
import myReviewSlice from "./slices/myAccount/myReview-slice";
import myDonationSlice from "./slices/myAccount/myDonation-slice";
import userProfileReviewSlice from "./slices/myAccount/userProfileReview-slice";
import accountDetailSlice from "./slices/myAccount/accountDetail-slice";
import sendVerificationMailSlice from "./slices/myAccount/sendVerificationMail";
import personalFundraiserSlice from "./slices/myAccount/personalFundraiser-slice";
import fundRaiserDetailSlice from "./slices/myAccount/fundRaiserDetail-slice";
import nonprofitDonationSlice from "./slices/myNonprofit/nonprofitDonation-slice";
import nonprofitMediaSlice from "./slices/myNonprofit/nonprofitMedia-slice";
import userNonprofitSlice from "./slices/myNonprofit/nonprofitList-slice";
import nonprofitStatsSlice from "./slices/myNonprofit/nonprofitStats-slice";
import topCitiesSlice from "./slices/donationCamp/topCities-slice";
import nearByCitiesSlice from "./slices/location/nearBy-cities";
import resetPasswordSlice from "./slices/auth/resetPassword-slice";
import socialLoginSlice from "./slices/auth/socialLogin-slice";
import similarNonprofitsSlice from "./slices/donationCamp/similarNonprofits-slice";
import donateCartSlice from "./slices/donationCamp/donateCart-slice";
import ipAddressSlice from "./slices/ipAddress/ipAddressSlice";
import modulesSlice from "./slices/ipAddress/modulesSlice";
import causePreferenceSlice from "./slices/myAccount/myCausePreference"
import manageFundraiserSlice from "./slices/myAccount/manageFundraiser-slice"
import userFavNonprofitsSlice from "./slices/myAccount/userFavoriteOrgs"
import allCategoriesSlice from "./slices/allCauses/allCategories-slice"
import allNonprofitSlice from "./slices/allCauses/allNonprofits-slice"
import verifyEmailSlice from "./slices/myAccount/verifyEmail-slice"
import editNonprofitProfileSlice from "./slices/myNonprofit/editnonprofit-slice"
import reviewRolesSlice from "./slices/myNonprofit/reviewRole-slice"
import donateToSlice from "./slices/donationCamp/donateTo-slice"
import addCartDonateSlice from "./slices/donationCamp/addCartDonate-slice"
import topRatedNonprofitsSlice from "./slices/donationCamp/topRatedNonprofit-slice"
import nonprofitProfileSlice from "./slices/myNonprofit/nonprofitProfile-slice";
import campDetailByIdSlice from "./slices/donationCamp/campDetailById-slice";
import fundRaiserViewDetailSlice from "./slices/myAccount/fundRaiserViewDetail-slice";
import profileUpdatedSlice from "./slices/myAccount/profileUpdated-slice";
import addEditReviewSlice from "./slices/donationCamp/addEditReview-slice";
import listReviewSlice from "./slices/donationCamp/listReview-slice";
import updateReviewSlice from "./slices/donationCamp/updateReview-slice";
import retrieveReviewsSlice from "./slices/donationCamp/retrieveReviews-slice";
import flagSlice from "./slices/myNonprofit/flag-slice";
import featuredReviewSlice from "./slices/reviews/featuredReview"

const store = configureStore({
  reducer: {
    login: loginSlice,
    subscribe: subscribeSlice,
    totalCampCount: totalCountSlice,
    campCategory: campCategorySlice,
    allCategories: allCategoriesSlice,
    allNonprofits: allNonprofitSlice,
    nonprofits: nonprofitsSlice,
    blogList: blogListSlice,
    footerCities: citiesSlice,
    causes: causesSlice,
    signup: signupSlice,
    forgotUser: forgotSlice,
    searchNonprofit: searchNonprofitSlice,
    similarNonprofit: similarNonprofitSlice,
    campDetails: campDetailSlice,
    communityStory: communityStoriesSlice,
    campaigns: campaignsSlice,
    sponsors: sponsorSlice,
    nearestCities: nearestCitiesSlice,
    nearByCities: nearByCitiesSlice,
    starBadge: startBadgeSlice,
    badgeStatistics: badgeStatisticsSlice,
    greatNonProfit: greatNonProfitSlice,
    successStories: successStoriesSlice,
    elliottAdvocacy: elliottAdvocacySlice,
    aboutMembers: aboutMembersSlice,
    nonprofitMission: nonprofitMissionSlice,
    blogCategory: blogCategorySlice,
    blogDetail: blogDetailSlice,
    funders: fundersSlice,
    clients: clientSlice,
    solution: solutionsSlice,
    pressMedia: pressMediaSlice,
    endorsements: endorsementsSlice,
    supporters: supporterSlice,
    careers: careersSlice,
    donationNumbers: donationNumbersSlice,
    donationMakeDifference: donationMakeDifferenceSlice,
    topCauses: topCausesSlice,
    sendVerificationMail: sendVerificationMailSlice,
    topCities: topCitiesSlice,
    faqHelps: faqHelpsSlice,
    faqArticles: faqArticlesSlice,
    linkToUs: linkToUsSlice,
    advertising: advertisingSlice,
    yearBadge: yearBadgeSlice,
    getBadge: getBadgeSlice,
    faqUserGuide: faqUserGuideSlice,
    faqTopRatedAwards: faqTopRatedAwardsSlice,
    faqNonprofit: faqNonprofitSlice,
    faqDetail: faqDetailsSlice,
    contactUsFaq: contactUsFaqSlice,
    myReview: myReviewSlice,
    myDonation: myDonationSlice,
    userProfileReview: userProfileReviewSlice,
    accountDetail: accountDetailSlice,
    personalFundraiser: personalFundraiserSlice,
    fundRaiserViewDetail: fundRaiserViewDetailSlice,
    fundRaiserDetail: fundRaiserDetailSlice,
    nonprofitDonation: nonprofitDonationSlice,
    nonprofitMedia: nonprofitMediaSlice,
    reviewRoles: reviewRolesSlice,
    userNonprofit: userNonprofitSlice,
    editNonprofitProfile: editNonprofitProfileSlice,
    nonprofitStats: nonprofitStatsSlice,
    userFavNonprofits: userFavNonprofitsSlice,
    resetPassword: resetPasswordSlice,
    socialLogin: socialLoginSlice,
    similarNonprofits: similarNonprofitsSlice,
    ipAddress: ipAddressSlice,
    modules: modulesSlice,
    causePreference: causePreferenceSlice,
    manageFundraiser: manageFundraiserSlice,
    donateCart: donateCartSlice,
    donateTo: donateToSlice,
    addCartDonate: addCartDonateSlice,
    topRatedNonprofits: topRatedNonprofitsSlice,
    nonprofitProfile: nonprofitProfileSlice,
    campDetailById: campDetailByIdSlice,
    profileUpdated: profileUpdatedSlice,
    addEditReview: addEditReviewSlice,
    listReview: listReviewSlice,
    verifyEmail: verifyEmailSlice,
    updateReview: updateReviewSlice,
    retrieveReview: retrieveReviewsSlice,
    flag: flagSlice,
    featuredReview: featuredReviewSlice,

  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default store;

